import React from 'react';
const facts = [{
  value: '52',
  label: 'Weekly sessions, ready to run',
  color: 'text-coral-deep'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses',
  color: 'text-indigo'
}, {
  value: '3',
  label: 'Levels on every drill',
  color: 'text-teal-deep'
}, {
  value: '45\u2013120',
  label: 'Minutes \u2014 timed for your slot',
  color: 'text-amber-deep'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-376" data-mp="32jmpgazrplm6">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-12" data-id="element-377" data-mp="32ibnmgpvunxp">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cloud-dark bg-cloud-dark sm:grid-cols-4" data-id="element-378" data-mp="2xjs0we3gt84a">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-379" data-mp="2ojbx13it7yyw">
              <div className={`font-display text-4xl font-extrabold leading-none sm:text-5xl ${fact.color}`} data-id="element-380" data-mp="2olfylet8klw0">{fact.value}</div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-381" data-mp="1d4ga6ua0er79">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}